import { Expose } from "class-transformer";
import { BaseEntity } from "./entity";

export default class EntityEnum extends BaseEntity {
  @Expose() key!: string | null;
  @Expose() value!: string;
}
